<script setup lang="ts">
import UserDetailView from '@/components/User/UserDetailView.vue'
import { type UserModel } from '@/types/models/UserModel'

type Props = {
    data: Partial<UserModel>
    submitted: boolean
    loading?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'click'): void
    (e: 'change', value: Partial<UserModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <UserDetailView
        :data="data"
        :label="$t('common.create')"
        :submitted="submitted"
        hasPermission
        :loading="loading"
        @click="$emit('click')"
        @update="$emit('change', $event)">
        <slot />
    </UserDetailView>
</template>
